var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListItem',_vm._g(_vm._b({attrs:{"title":_vm.name || _vm.nameFromStore,"subtitle":_vm.subtitleContent,"subtitle-monospace":""}},'ListItem',_vm.$attrs,false),_vm.$listeners),[_c('AeIdenticon',{attrs:{"slot":"icon","address":_vm.address},slot:"icon"}),_vm._l((Object.keys(_vm.$slots)),function(slot){return _vm._t(slot,null,{"slot":slot})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }